<template>
  <div v-click-outside="hideSubmenu"
       id="main-nav"
       :class="[{'main-nav--visible': navVisible}, {'main-nav--sub-nav-visible': visibleSubmenu}, {'main-nav--save-in-progress': saveInProgress}]"
       :key="hotelSettings.hotel.id"
       class="main-nav">
    <div :class="[{'main-nav__header--white': $route.meta.headerMode === 'white'}, `main-nav__header--${env('WHITE_LABEL_KEY')}` ]" class="main-nav__header" @click="onClickLogo">
      <span v-if="$route.meta.headerMode === 'white'" class="main-nav__header__label">{{ $t('menu.back') }}</span>
    </div>
    <nav class="main-nav__nav">
      <ul class="main-nav__ul">
        <template v-if="!hotelSettings.details.deactivated">
          <router-link id="nav_home"
                       :to="{ name: 'home' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li"
                       exact>
            <a v-tooltip="{ title: $t('menu.home'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-home" />
              <span v-t="'menu.home'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasLicense('RoomPlan') && (hasRole('ROLE_USER') || hasRole('ROLE_UNIT_OWNER'))"
                       id="nav_roomplan"
                       :to="{ name: 'roomplan' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li">
            <a v-tooltip="{ title: $t('menu.roomplan'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-plan" />
              <span v-t="'menu.roomplan'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasRole('ROLE_USER')"
                       id="nav_findreservation"
                       :to="{ name: 'findReservation' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li">
            <a v-tooltip="{ title: $t('menu.reservation'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-reservation" />
              <span v-t="'menu.reservation'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasLicense('SelfCheckIn') && hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                       id="nav_selfcheckin"
                       :to="{ name: 'reviewSelfCheckInCandidates' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li">
            <a v-tooltip="{ title: $t('menu.selfcheckin'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-tablet-check" />
              <span v-t="'menu.selfcheckin'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasLicense('Inquiry') && hasRole('ROLE_USER')"
                       id="nav_inquiry"
                       :to="{ name: 'findInquiry' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li"
                       exact>
            <a v-tooltip="{ title: $t('menu.inquiry'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-inquiry" />
              <span v-t="'menu.inquiry'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasRole('ROLE_USER')"
                       id="nav_findoffer"
                       :to="{ name: 'findOffer' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li"
                       exact>
            <a v-tooltip="{ title: $t('menu.offer'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-quote" />
              <span v-t="'menu.offer'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasRole('ROLE_USER')"
                       id="nav_findguest"
                       :to="{ name: 'findGuest' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li">
            <a v-tooltip="{ title: $t('menu.guest'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-guest" />
              <span v-t="'menu.guest'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasAnyRole(['ROLE_INVOICING', 'ROLE_ADMIN', 'ROLE_SYSADMIN']) && hasLicense('CashBook') && hasRole('ROLE_USER')"
                       id="nav_cashbook"
                       :to="{ name: 'cashBook' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li">
            <a v-tooltip="{ title: $t('menu.cashBook'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-cash-register" />
              <span v-t="'menu.cashBook'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasRole('ROLE_USER')"
                       id="nav_cockpit"
                       :to="{ name: 'cockpit' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li"
                       exact>
            <a v-tooltip="{ title: $t('menu.cockpit'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-gauge" />
              <span v-t="'menu.cockpit'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <router-link v-if="hasAnyRole(['ROLE_USER','ROLE_UNIT_OWNER_REPORTS'])"
                       id="nav_reports"
                       :to="{ name: 'listReports' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li">
            <a v-tooltip="{ title: $t('menu.reports'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-report" />
              <span v-t="'menu.reports'" class="main-nav__link__label"></span>
            </a>
          </router-link>
        </template>
        <li class="main-nav__li">
          <a v-tooltip="{ title: $t('menu.settings'), placement: 'right', positionFixed: true, trigger: 'hover' }"
             id="nav_settings"
             href="javascript:void(0);"
             class="main-nav__link"
             @click="onClickSettings">
            <icon icon="fill-settings" />
            <span v-t="'menu.settings'" class="main-nav__link__label"></span>
          </a>
          <settings-sub-nav :open="submenuVisible('settings')" />
        </li>
        <template v-if="!hotelSettings.details.deactivated">
          <router-link v-if="isHotelmeister"
                       id="nav_support"
                       :to="{ name: 'support' }"
                       tag="li"
                       active-class="main-nav__li--active"
                       class="main-nav__li">
            <a v-tooltip="{ title: $t('menu.support'), placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link">
              <icon icon="fill-support" />
              <span v-t="'menu.support'" class="main-nav__link__label"></span>
            </a>
          </router-link>
          <!--
          <li v-if="!isNil(hotelSettings) && !isNil(hotelSettings.tenant) && hotelSettings.tenant.subdomain === 'bacherleogang'" class="main-nav__li">
            <a v-tooltip="{ title: 'Speedtest', placement: 'right', positionFixed: true, trigger: 'hover' }" href="#" class="main-nav__link"
               @click="$serviceBus.$emit('speedtest')">
              <icon icon="replace" />
              <span class="main-nav__link__label">Speedtest</span>
            </a>
          </li>
          -->
          <li class="main-nav__li main-nav__hr main-nav__li--app-install">
            <a v-tooltip="{ title: $t('menu.install'), placement: 'right', positionFixed: true, trigger: 'hover' }"
               id="nav_installapp"
               href="javascript:void(0);"
               class="main-nav__link"
               @click="installApp">
              <icon icon="fill-hm" />
              <span v-t="'menu.install'" class="main-nav__link__label"></span>
            </a>
          </li>
          <li class="main-nav__li main-nav__hr main-nav__li--update-new-version">
            <a v-tooltip="{ title: $t('menu.updateNewVersion'), placement: 'right', positionFixed: true, trigger: 'hover' }"
               id="nav_updateversion"
               href="javascript:void(0);"
               class="main-nav__link"
               @click="$serviceBus.$emit('menu.updateNewVersion')">
              <icon icon="fill-refresh" />
              <span v-t="'menu.updateNewVersion'" class="main-nav__link__label"></span>
            </a>
          </li>
        </template>
        <li class="main-nav__li main-nav__hr">
          <a v-tooltip="{ title: $t('menu.logout'), placement: 'right', positionFixed: true, trigger: 'hover' }"
             id="nav_logout"
             class="main-nav__link"
             href="javascript:void(0);"
             @click="logout">
            <icon icon="fill-logout" />
            <span v-t="'menu.logout'" class="main-nav__link__label"></span>
          </a>
        </li>
        <li v-if="canReload" class="main-nav__li main-nav__hr main-nav__li--reload">
          <a v-tooltip="{ title: $t('menu.reload'), placement: 'right', positionFixed: true, trigger: 'hover' }"
             id="nav_reloadPage"
             class="main-nav__link"
             href="javascript:void(0);"
             @click="reloadPage">
            <icon icon="fill-refresh" />
            <span v-t="'menu.reload'" class="main-nav__link__label"></span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>

import { isEmpty, isNil, throttle } from 'lodash';
import { hideAll } from 'tippy.js';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import UpdateHotelSettingsMixin from '../../../../mixins/UpdateHotelSettingsMixin';
import SettingsSubNav from './SettingsSubNav';
import ReloadPageMixin from '../../../../mixins/ReloadPageMixin';

export default {
  name: 'MainNav',
  components: { SettingsSubNav },
  mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin, ReloadPageMixin],

  props: [],

  data() {
    return {
      submenu: null,
      onClickLogo: throttle(this._onClickLogo, 1000, { leading: true, trailing: false }),
    };
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('layout/navVisible', false);
    this.submenu = null;
    hideAll({ duration: 0 });

    next();
  },

  computed: {
    saveInProgress: function () {
      return this.$store.getters['save/saveInProgress'];
    },
    canReload: function () {
      if (isNil(this.$route)) return false;
      if (isNil(this.$route.meta)) return false;
      return this.$route.meta.reload === true;
    },
    isHotelmeister: function () {
      return !isNil(this.hotelSettings) && !isNil(this.hotelSettings.hotel) && this.hotelSettings.hotel.whiteLabel === 'Hotelmeister';
    },
    multiTenant: function () {
      return this.$store.getters['hotel/accessibleHotels'] > 1;
    },
    navVisible: function () {
      return this.$store.getters['layout/navVisible'];
    },
    visibleSubmenu: function () {
      return !isNil(this.submenu);
    },
  },

  created: function () {
    if (!isNil(this.$route.params.expandedSubmenu)) {
      this.showSubmenu(this.$route.params.expandedSubmenu);
    }
  },

  mounted: function () {
    this.$emit('widenav', false);
  },

  methods: {
    openUrl: function (event, url) {
      event.preventDefault();
      event.stopPropagation();
      window.openOldUI(
        this.hotelSettings.tenant.subdomain,
        this.hotelSettings.hotel.id,
        url,
        window.getToken(this.$route.params.hotelId),
        this.$shortLocale === 'de' ? this.$shortLocale : 'en',
      );
    },
    env: function (name) {
      return process.env[name];
    },
    logout: function () {
      this.addUIBreadcrumb('LOGOUT - user clicked logout button');
      this.$root.logout();
    },
    showSubmenu: function (submenu) {
      this.submenu = submenu;
    },
    hideSubmenu: function () {
      this.submenu = null;
    },
    toggleSubmenu: function (submenu) {
      if (this.submenu === submenu) {
        this.submenu = null;
      } else {
        this.submenu = submenu;
      }
    },
    submenuVisible: function (submenu) {
      if (this.$store.getters['layout/activeBreakpoint'] === 'mobile') {
        return this.submenu === submenu;
      } else {
        return submenu === 'settings' && isNil(this.submenu) ? true : this.submenu === submenu;
      }
    },
    installApp: function ($event) {
      window.installApp();
    },
    _onClickLogo: function () {
      if (!isEmpty(this.$route.meta.parent)) {
        this.$router.push({
          name: this.$route.meta.parent,
          params: {
            ...this.$route.params,
            expandedSubmenu: this.$route.meta.expandedSubmenu,
          },
        });
      }
      if (this.$route.meta.headerMode === 'white') {
        this.$root.$emit('clickHeaderBack');
      }
    },
    onClickSettings($event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      this.toggleSubmenu('settings');
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
  @import '~styles/components/lib/MainNav';

  .tooltip {
    display: none;
  }

  @media (min-width: $br-tablet) {
    .tooltip {
      display: block;
    }

    .main-nav__link {
      max-width: 50px;
      overflow: hidden;
    }
  }

  .main-nav{
    &__nav {
      display: flex;
    }
    &__ul {
      //align-self: stretch;
      width: 100%;
      display: grid;
      grid-template-rows: repeat(20, max-content) auto max-content;
      grid-template-areas:
        "1"
        "2"
        "3"
        "4"
        "5"
        "6"
        "7"
        "8"
        "9"
        "10"
        "11"
        "12"
        "13"
        "14"
        "15"
        "16"
        "17"
        "18"
        "19"
        "20"
        "filler"
        "reload";
    }
    &__li--reload {

      grid-area: reload;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/MainNav.vue